import Vue from 'vue';
import gql from 'graphql-tag';

export default {
    namespaced: true,
    actions: {
        confirmRegistration({}, options) {
            return Vue.$graphql
                .mutate({
                    mutation: gql`
                        mutation confirmRegistration($hash: String!, $language: String!) {
                            confirmRegistration(hash: $hash, language: $language)
                        }
                    `,
                    variables: {
                        hash: options.hash,
                        language: Vue.$language.getLanguage(),
                    },
                })
                .then(r => r.data)
                .then(data => data.confirmRegistration);
        },
    },
};